import { createContext } from "react";
const cryptoContext = createContext();
export default cryptoContext;
